import { render, staticRenderFns } from "./Pos_sale_history.vue?vue&type=template&id=9c0c3fca&scoped=true&"
import script from "./Pos_sale_history.vue?vue&type=script&lang=js&"
export * from "./Pos_sale_history.vue?vue&type=script&lang=js&"
import style0 from "./Pos_sale_history.vue?vue&type=style&index=0&id=9c0c3fca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0c3fca",
  null
  
)

export default component.exports